import one from "./Swords01.jpg";
import two from "./Swords02.jpg";
import three from "./Swords03.jpg";
import four from "./Swords04.jpg";
import five from "./Swords05.jpg";
import six from "./Swords06.jpg";
import seven from "./Swords07.jpg";
import eight from "./Swords08.jpg";
import nine from "./Swords09.jpg";
import ten from "./Swords10.jpg";
import page from "./Swords11.jpg";
import knight from "./Swords12.jpg";
import queen from "./Swords13.jpg";
import king from "./Swords14.jpg";

const swords = [
  one,
  two,
  three,
  four,
  five,
  six,
  seven,
  eight,
  nine,
  ten,
  page,
  knight,
  queen,
  king,
];

export default swords;
